import { observer } from 'mobx-react-lite';
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { authorizationStore } from '../../modules/authorization/authorization.store';
import Button from '../../ui/button';
import { TitlePiece } from './pieces/title-piece';
import { InputsPiece } from './pieces/inputs-piece';
import { RememberMePiece } from './pieces/rememberMe-piece';
import { TermsPrivacyPiece } from './pieces/terms-privacy-piece';
import { dashboardStore } from '../../layout/dashboard/dashboard.store';
import { ResendPiece } from './pieces/resend-piece';
import { LoginWithPiece } from './pieces/loginWith-piece';
import AuthSectionSwitch from '../authSectionSwitch';
import VerificationPopup from '../verificationPopup';
import { ReactComponent as Spiner } from '../../assets/icons/loadingDots.svg';
import './styles.scss';

export const AuthMainBlock: React.FC = observer((): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);
  const { sectionContent, typeofSection, openUnverifiedPopup } =
    authorizationStore;
  const [searchParams, setSearchParams] = useSearchParams();
  const { authPopupActive } = dashboardStore;

  const btnFunction = async () => {
    setIsLoading(true);
    const success = await (
      authorizationStore[
        sectionContent?.button?.func as keyof typeof authorizationStore
      ] as Function
    )();
    setIsLoading(false);
    if (!success) return;
  };

  const goTo = (): void => {
    if (!sectionContent?.subtitle?.navigation?.url) return;
    searchParams.set(
      'auth',
      sectionContent?.subtitle?.navigation?.url as string,
    );
    setSearchParams(searchParams, { replace: true });
  };

  useEffect(() => {
    if (authPopupActive) {
      document.body.style.overflowY = 'hidden';
    }
    return () => {
      document.body.style.overflowY = 'scroll';
    };
  }, []);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!sectionContent?.button?.disabled && !isLoading) {
      btnFunction();
    }
  };

  return (
    <div className="popupAuth">
      <form onSubmit={handleSubmit} className="popupAuthForm">
        <TitlePiece
            backButton={sectionContent.backButton}
            title={sectionContent.title}
            subtitle={sectionContent.subtitle}
            step={sectionContent.step}
            goTo={goTo}
            typeofSection={typeofSection}
            bottom={false}
        />
        <InputsPiece
            inputs={sectionContent.inputs}
            typeofSection={typeofSection}
        />
        {sectionContent.error.status && (<div className="errorText errorSection">
              {sectionContent.error.message}
            </div>)}
        {sectionContent.resend?.status && (<ResendPiece func={sectionContent?.resend?.func} />)}
        <RememberMePiece rememberMeBlock={sectionContent.rememberMeBlock} />

        <Button
            type="rounded-15"
            size="w100 lg"
            color="dark"
        >
          <span className="buttonTxt">
            {isLoading ? <Spiner /> : sectionContent?.button.text}
          </span>
        </Button>

        <AuthSectionSwitch
            goTo={goTo}
            subtitle={sectionContent.subtitle}
            typeofSection={typeofSection}
            bottom
            step={sectionContent.step}
        />
        <TermsPrivacyPiece termsandPrivecy={sectionContent.termsandPrivecy} />
      </form>


      <LoginWithPiece loginWith={sectionContent.loginWith} />

      <span className="divider"></span>

      <Button
          type="rounded-15"
          size="w100 lg"
          color="text"
      >
        <span className="buttonTxt popupBtnText">Cancel</span>
      </Button>

      {openUnverifiedPopup && <VerificationPopup />}
    </div>);
});
